import AppLayout from "../../components/Layout";
import { Card, Table, TableColumnsType, Tabs } from "antd";
import PreIntervention from "./PreIntervention";
import LabelText from "../../components/LabelText";
import DailyIntervention from "./DailyIntervention";
import { getSummaryPreIntervention } from "../../services/adminController";
import { useQuery } from "@tanstack/react-query";
import { formatRupee } from "../../utils";
import { useParams } from "react-router-dom";

const Analytics = () => {
  const lenderData = useParams();
  const lenderId = lenderData?.lenderId

  const { data, isLoading, isError } = useQuery({
    queryKey: ["summaryPreIntervention", lenderId],
    queryFn: () => getSummaryPreIntervention(lenderId || ""),
    // staleTime: 5 * 60 * 1000, // optional: 5 min cache
  });

 const summary_Data = isError ? {} : data?.data || {};
  const items = [
    {
      label: "Pre Intervention Analysis",
      key: "1",
      children: <PreIntervention />
    },
    {
      label: "Daily Intervention Analysis",
      key: "2",
      children: <DailyIntervention />
    },
  ];
  return (
    <AppLayout >
      <Card title="Summary" className="my-5" >
        <div className="grid grid-cols-3 gap-4">
          <LabelText label="Lender Name" text={summary_Data?.lenderName ?? "NA"} />
           <div/>
                <LabelText label="Last Updated Date (Pre-Intervention)" text={summary_Data?.lastUpdated
            ? new Date(summary_Data.lastUpdated).toLocaleString("en-IN", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true, // for AM/PM format
              timeZone: "Asia/Kolkata"
            })
            : "NA"}
          />
          <LabelText label="Total Borrowers (All Time)" text={summary_Data?.totalBorrowerCount ?? "NA"} />
          <LabelText label="Total Original Principal (All Time)" text={formatRupee(summary_Data?.totalLoanAmount) ?? "NA"} />
          <LabelText label="Total Outstanding  (All Time)" text={formatRupee(summary_Data?.totalOSAmount) ?? "NA"} />
          <LabelText label="Total Pre-Intervention Outstanding" text={formatRupee(summary_Data?.preInteOSAmount) ?? "NA"} />
          <LabelText label="Total Pre-Intervention Borrower Count" text={summary_Data?.preInteBorrowerCount ?? "NA"} />
            <LabelText label="Month-to-Date (MTD) Collection" text={formatRupee(summary_Data?.mtdTotal) ?? "NA"} />
       
         
          {/* <LabelText label="Status" text="NA" /> */}
        </div>
      </Card>
      <Tabs items={items}></Tabs>
    </AppLayout>
  );
};

export default Analytics;